import { forwardRef } from 'react'
import { Dialog } from '@mote/ui'

export const GenericRecorderErrorsTemplate = forwardRef(
  ({ header, content, buttons, footerProps = {}, ...props }, ref) => {
    return (
      <Dialog
        isOpen
        containerProps={{ containerRef: ref }}
        maxWidth={400}
        {...props}
      >
        {header && <Dialog.Header>{header}</Dialog.Header>}
        <Dialog.Content>{content}</Dialog.Content>
        {buttons && <Dialog.Footer {...footerProps}>{buttons}</Dialog.Footer>}
      </Dialog>
    )
  }
)
